/* ============================================================
   MIONA · Gravur Add-on Warenkorb-Verknüpfung
   ------------------------------------------------------------
   Legt beim Add-to-Cart eines Rings mit Gravur zusätzlich das
   Gravur-Produkt in den Warenkorb (verknüpft per Line-Item-Key)
   und entfernt es wieder, wenn der Ring entfernt wird.

   Konfig kommt aus window.MIONA_GRAVUR (siehe snippets/miona-gravur.liquid).
   Bei enabled=false passiert NICHTS. Seit 10.08.2026 scharf geschaltet.

   Theme = Motion/Archetype: nach dem Add feuert "variant:add" +
   "cart:change" (auf documentElement), Drawer-Update via
   Event "cart:refresh". Kein Eingriff in theme.js.
   ============================================================ */
(function () {
  "use strict";

  var CFG = window.MIONA_GRAVUR || {};
  var VARIANT_ID = parseInt(CFG.variantId, 10);
  if (!CFG.enabled || !VARIANT_ID) return; // dormant / nicht scharf geschaltet

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var busy = false; // verhindert Rekursion (unsere eigenen Cart-Änderungen)

  function isGravur(li) {
    return (li.variant_id === VARIANT_ID) || (li.id === VARIANT_ID);
  }
  function getCart() {
    return fetch(ROOT + "cart.js", { headers: { "X-Requested-With": "XMLHttpRequest" } }).then(function (r) {
      return r.json();
    });
  }
  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  }

  // 1) Ring mit Gravur hinzugefügt -> Gravur-Produkt nachlegen, verknüpft per _gravur_for = Ring-Line-Key.
  document.documentElement.addEventListener("variant:add", function (e) {
    if (busy) return;
    var items = (e.detail && e.detail.items) || [];
    var rings = items.filter(function (it) {
      return !isGravur(it) && it.properties && it.properties.Gravur && String(it.properties.Gravur).trim() !== "";
    });
    if (!rings.length) return;

    busy = true;
    getCart()
      .then(function (cart) {
        var toAdd = [];
        rings.forEach(function (ring) {
          var already = cart.items.some(function (li) {
            return isGravur(li) && li.properties && li.properties._gravur_for === ring.key;
          });
          if (!already) {
            toAdd.push({ id: VARIANT_ID, quantity: ring.quantity || 1, properties: { _gravur_for: ring.key } });
          }
        });
        if (!toAdd.length) {
          busy = false;
          return;
        }
        return fetch(ROOT + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ items: toAdd }),
        }).then(function () {
          busy = false;
          refreshDrawer();
        });
      })
      .catch(function () {
        busy = false;
      });
  });

  // 2) Warenkorb geaendert -> alle Gravur-Zeilen nachziehen.
  //
  //    WICHTIG, hier lag ein Fehler: frueher wurde pro Ereignis genau EINE
  //    Korrektur angewendet, in der Annahme, die eigene Aenderung loese wieder
  //    ein cart:change aus. Das tut sie nicht, wir schicken nur cart:refresh.
  //    Mit zwei gravierten Ringen im Warenkorb blieb die zweite Zeile deshalb
  //    stehen wie sie war. Jetzt wird so lange korrigiert, bis nichts mehr zu
  //    tun ist, mit einer Obergrenze gegen Endlosschleifen.
  //
  //    Behandelt werden drei Faelle:
  //    a) Ring entfernt          -> zugehoerige Gravur entfernen
  //    b) Ringmenge geaendert    -> Gravurmenge angleichen
  //    c) Gravur-Zeile entfernt  -> Gravurtext vom Ring nehmen
  //       (letzter Fall ist ein Netz: ueber die Oberflaeche laesst sich die
  //        Gravur nicht mehr einzeln loeschen)

  function naechsteKorrektur(cart) {
    var ringe = {};
    cart.items.forEach(function (li) {
      if (!isGravur(li)) ringe[li.key] = li.quantity;
    });

    for (var i = 0; i < cart.items.length; i++) {
      var li = cart.items[i];
      if (!isGravur(li) || !li.properties || !li.properties._gravur_for) continue;
      var ringMenge = ringe[li.properties._gravur_for];
      if (ringMenge === undefined) return { id: li.key, quantity: 0 };        // a
      if (ringMenge !== li.quantity) return { id: li.key, quantity: ringMenge }; // b
    }

    for (var j = 0; j < cart.items.length; j++) {
      var ring = cart.items[j];
      if (isGravur(ring)) continue;
      var text = ring.properties && ring.properties.Gravur;
      if (!text || String(text).trim() === "") continue;

      var hatZeile = cart.items.some(function (g) {
        return isGravur(g) && g.properties && g.properties._gravur_for === ring.key;
      });
      if (hatZeile) continue;

      var rest = {};                                                          // c
      Object.keys(ring.properties || {}).forEach(function (k) {
        if (k !== "Gravur") rest[k] = ring.properties[k];
      });
      return { id: ring.key, properties: rest };
    }
    return null;
  }

  function aendern(fix) {
    return fetch(ROOT + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify(fix),
    }).then(function (r) {
      return r.json();
    });
  }

  // ---- Warenkorb-Zaehler oben rechts ----
  // Das Theme setzt dort cart.item_count, und darin steckt die Gravur als
  // eigener Artikel. Ein gravierter Ring wuerde also als 2 gezaehlt.
  // Wir merken uns die richtige Zahl und schreiben sie zurueck. Ein Beobachter
  // ist noetig, weil das Theme den Wert nach uns setzt und wir sonst
  // ueberschrieben wuerden.
  var ringZahl = null;

  function zaehlerSchreiben() {
    if (ringZahl === null) return;
    document.querySelectorAll("cart-count").forEach(function (el) {
      if (el.textContent.trim() !== String(ringZahl)) el.textContent = ringZahl;
    });
  }

  function ringZahlMerken(cart) {
    var n = 0;
    cart.items.forEach(function (li) {
      if (!isGravur(li)) n += li.quantity;
    });
    ringZahl = n;
    zaehlerSchreiben();
  }

  if (window.MutationObserver) {
    var beobachter = new MutationObserver(zaehlerSchreiben);
    var starten = function () {
      document.querySelectorAll("cart-count").forEach(function (el) {
        beobachter.observe(el, { childList: true, characterData: true, subtree: true });
      });
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", starten);
    } else {
      starten();
    }
    document.addEventListener("cart:refresh", starten);
  }

  // Beim Laden einmal selbst nachsehen. Das Theme holt sich den Warenkorb
  // ebenfalls und schreibt cart.item_count in das Abzeichen, also inklusive
  // Gravur. Ohne diesen Aufruf stuende dort bis zur ersten Warenkorb-Aenderung
  // die falsche Zahl.
  getCart().then(ringZahlMerken).catch(function () {});

  document.documentElement.addEventListener("cart:change", function () {
    // Der Zaehler wird IMMER neu bestimmt, auch waehrend eine Korrektur laeuft.
    // Sonst haelt der Beobachter eine veraltete Zahl fest, bis das naechste
    // Ereignis kommt.
    getCart().then(ringZahlMerken).catch(function () {});

    if (busy) return;
    busy = true;

    var runden = 0;
    function durchgang(cart) {
      var fix = naechsteKorrektur(cart);
      if (!fix || ++runden > 20) {
        busy = false;
        ringZahlMerken(cart);
        if (runden > 0) refreshDrawer();
        return;
      }
      // Nach jeder Aenderung frisch lesen: beim Aendern von Eigenschaften
      // vergibt Shopify der Zeile einen neuen Schluessel.
      return aendern(fix).then(function () {
        return getCart().then(durchgang);
      });
    }

    getCart()
      .then(durchgang)
      .catch(function () {
        busy = false;
      });
  });
})();
